module.exports = __webpack_public_path__ + "vue/img/bad-portrait-photo1.4d8e429b.jpg";